<template>
  <div>
    <form-loader v-if="loading"/>
    <template v-if="!loading">
      <b-modal ref="open-payments-modal" title="Inschrijfgeld moet nog worden voldaan">
        <p class="my-4">
          <template v-if="personMustPay && !partnerMustPay">
            Uw inschrijfgeld is nog niet voldaan, wanneer u verder gaat zonder de betaling te verrichten kan u niet
            reageren op woningen.
          </template>
          <template v-if="!personMustPay && partnerMustPay">
            Het inschrijfgeld voor uw partner is nog niet voldaan, wanneer u verder gaat zonder de betaling te
            verrichten kan u niet reageren op woningen.
          </template>
          <template v-if="personMustPay && partnerMustPay">
            Het inschrijfgeld voor u en uw partner is nog niet voldaan, wanneer u verder gaat zonder de betaling te
            verrichten kan u niet reageren op woningen.
          </template>
        </p>
        <template #modal-footer="{cancel }">
          <b-button variant="success" @click="cancel()">
            Terug
          </b-button>
          <b-button variant="secondary" @click="next(true)">
            Doorgaan zonder te betalen
          </b-button>
        </template>
      </b-modal>

      <br>
      <h2>Betaling per inschrijving</h2>
      <template v-if="personMustPay || partnerMustPay">
        <b-form-group class="payment-radios">

          <b-form-radio v-if="personMustPay" v-model="paymentOption" name="payment-choice" value="self">
            Inschrijfgeld te voldoen voor {{ personName }}
            <span class="amount">€ {{ paymentInfo.person.amount }}</span>
          </b-form-radio>

          <b-form-radio v-if="!personMustPay & partnerMustPay" v-model="paymentOption" name="payment-choice"
                        value="partner">
            Inschrijfgeld te voldoen voor {{ partnerName }}
            <span class="amount">€ {{ paymentInfo.partner.amount }}</span>
          </b-form-radio>

          <b-form-radio v-if="personMustPay && partnerMustPay" v-model="paymentOption" name="payment-choice"
                        value="both">
            Inschrijfgeld te voldoen voor {{ personName }} en {{ partnerName }}
            <span class="amount">€ {{ bothAmount }}</span>
          </b-form-radio>

        </b-form-group>

        <div class="text-center">
          <b-button variant="success" :disabled="paymentOption === null" class="d-inline-block" block @click.stop="pay">
            Betaal het inschrijfgeld
          </b-button>
        </div>
      </template>
      <template v-if="!(personMustPay || partnerMustPay)">
        <div>
          <p v-if="'partner' in paymentInfo">Het inschrijfgeld voor u en uw partner is reeds voldaan.</p>
          <p v-if="!('partner' in paymentInfo)">U heeft uw inschrijfgeld reeds voldaan.</p>
        </div>
      </template>
      <br>
      <error-box v-if="postErrors.length > 0" :errors="postErrors"/>
      <FormButtons @next="next(false)" @previous="$emit('previous')"/>
    </template>
  </div>

</template>
<script>


import FormLoader from '@/components/_registration/FormLoader'
import FormButtons from '@/components/_registration/FormButtons'
import { registrationService } from '@/_services/registration.service'
import ErrorBox from '@/components/_registration/ErrorBox'

export default {
  components: { FormButtons, FormLoader, ErrorBox },
  name: 'Payment',
  data: () => {
    return {
      postErrors: [],
      paymentOption: null,
      loading: false,
      paymentInfo: {
        person: {
          mustPay: true,
          amount: null,
          info: {
            initials: null,
            lastname: null
          }
        },
        partner: {
          amount: null,
          info: {
            initials: null,
            lastname: null,
          }
        },
        both: {
          amount: null,
        }
      },
    }
  },
  computed: {
    bothAmount () {
      if ('partner' in this.paymentInfo) {
        return (parseFloat(this.paymentInfo.person.amount) + parseFloat(this.paymentInfo.partner.amount)).toFixed(2)
      }
      return parseFloat(this.paymentInfo.person.amount).toFixed(2)
    },

    partnerName () {
      if ('partner' in this.paymentInfo)
        return `${this.paymentInfo.partner.info.initials} ${this.paymentInfo.partner.info.lastname}`
      return ''
    },
    personName () {
      return `${this.paymentInfo.person.info.initials} ${this.paymentInfo.person.info.lastname}`
    },
    partnerMustPay () {
      if ('partner' in this.paymentInfo) {
        return this.paymentInfo.partner.mustPay
      }
      return false
    },
    personMustPay () {
      return this.paymentInfo.person.mustPay
    },
  },
  methods: {
    fetchData () {
      this.loading = true
      registrationService.getPaymentInfo().then(result => {
        this.paymentInfo = result
      }).finally(() => {
        this.loading = false
      })
    },
    pay () {
      this.loading = true
      registrationService.getPaymentLink(this.paymentOption).then(result => {
        if ('errors' in result) {
          this.postErrors = result.errors
          this.loading = false
        } else {
          this.postErrors.errors = []
          window.location.href = result.url
        }
      })
    },
    next (force) {
      if (!force && (this.personMustPay || this.partnerMustPay)) {
        this.$refs['open-payments-modal'].show()
        return
      }
      if (force) {
        this.$refs['open-payments-modal'].hide()
      }
      this.$emit('validated', true)
      this.$emit('next')
    },

  },
  mounted () {
    this.fetchData()
  },
  activated () {
    this.fetchData()
  },
}
</script>
<style lang="scss" scoped>
.amount {
  float: right;
}
</style>
<style lang="scss">
.payment-radios .custom-control-label {
  display: inline;
  margin: 5px 0;
}

.payment-radios .custom-radio {
  margin: 6px 0;
}
</style>